export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-hearing-aid-f30418d5de1908447fd7793f20764310.svg";